import { Card } from '@mantine/core';
import classes from './TouringCard.module.css';

type TouringCardPropsType = React.PropsWithChildren;

export const TouringCard: React.FC<TouringCardPropsType> = ({
  children,
  ...props
}) => {
  return (
    <Card className={classes.root} {...props}>
      {children}
    </Card>
  );
};
